// @ts-check
import React from "react";
import classes from './layout.module.scss';
import LnIcon from "components/LnIcon";
import { useAppDispatch } from "src/utils/ReduxHooks";
import { searchDuck } from "../search/SearchDuck";
import useTypedSelector from "utils/useTypedSelector";
import { useI18n } from "components/lni18n";

const SearchMenu = (props) => {

    const dispatch = useAppDispatch();
      const { languageService: t } = useI18n();
    const { showSearch } = useTypedSelector(state => state.search)

    const toggleOpen = () => {
        dispatch(searchDuck.toggleShow(!showSearch));
    }


    return <div aria-label={t.getText("search")} key="search" className={classes["search"]}>
        <div>

            <div className={classes.dropDownItem + " btn btn-minimal pointer"} onClick={() => toggleOpen()}>
                <LnIcon name="search-icon" />
            </div>


        </div>
    </div>
}

export default SearchMenu;